<template>
  <div class="over">
    <div class="evaluation">
      运营信息
    </div>
    <div class="info">
      <div class="info_row">
        <div class="info_row_item">
          <p>今日售电</p>
          <p class="info_row_item_price">1264.71 <i style="font-size: 16rem">￥</i></p>
          <p>环比增长9.46%</p>
        </div>
        <div class="info_row_item">
          <p>累计售电</p>
          <p class="info_row_item_price">24417.53 <i style="font-size: 16rem">￥</i></p>
        </div>
      </div>
      <div class="info_row">
        <div class="info_row_item">
          <p>今日充电度数</p>
          <p class="info_row_item_price">1028.22 <i style="font-size: 16rem">kWh</i></p>
          <p>环比增长3.74%</p>
        </div>
        <div class="info_row_item">
          <p>累计充电度数</p>
          <p class="info_row_item_price">19851.65 <i style="font-size: 16rem">kWh</i></p>
        </div>
      </div>
      <div class="useStatus">
        <div>使用状态</div>
        <div class="useStatus_pic">
          <div
              class="useStatus_pic_div"
              v-for="item in list"
              :key="item.id"
              :style="'backgroundColor: ' + item.color"
          ></div>
          <div class="useStatus_pic_num">
            <i style="color: #f6bd16">{{ handleCounts(false) }}</i>
            <i style="color: #01ab65">/{{ handleCounts(true) }}</i>
          </div>
          <div class="useStatus_pic_icon" style="background-color: #f6bd16;">忙</div>
          <div class="useStatus_pic_icon" style="background-color: #01ab65;">闲</div>
        </div>
      </div>
    </div>
    <div class="evaluation">
      费率设置
      <div style="float: right">
        当前费率时段[9：00 ~ 15：00]
      </div>
    </div>
    <div class="rate">
      <div class="rate_item">
        <div>
          电价
          <a class="rate_item_link" href="javascript:;">修改</a>
        </div>
        <div class="rate_item_price">
          1.0726
          <i style="font-size: 16rem">￥</i>
        </div>
      </div>
      <div class="rate_item">
        <div>
          服务费
          <a class="rate_item_link" href="javascript:;">修改</a>
        </div>
        <div class="rate_item_price">
          0.3574
          <i style="font-size: 16rem">kWh</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [
        {
          id: 0,
          isFree: false,
          color: '#f6bd16'
        }, {
          id: 1,
          isFree: false,
          color: '#f6bd16'
        }, {
          id: 2,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 3,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 4,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 5,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 6,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 7,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 8,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 9,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 10,
          isFree: true,
          color: '#01ab65'
        },{
          id: 11,
          isFree: true,
          color: '#01ab65'
        },{
          id: 12,
          isFree: true,
          color: '#01ab65'
        },{
          id: 13,
          isFree: true,
          color: '#01ab65'
        },{
          id: 14,
          isFree: true,
          color: '#01ab65'
        },
      ]
    }
  },

  mounted() {
  },
  methods: {
    handleCounts(flag) {
      return this.list.filter(item => {
        return item.isFree === flag
      }).length
    }
  }
}
</script>

<style lang="less" scoped>
.over {
  .evaluation {
    height: 3.2vh;
    padding-top: 7rem;
    padding-left: 13rem;
    line-height: 28rem;
    box-sizing: border-box;
    font-size: 16rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    position: relative;

    &::before {
      content: '';
      width: 5rem;
      height: 18rem;
      background: #0D94FF;
      position: absolute;
      left: 0;
      top: 12.5rem;
    }
  }

  .rate {
    height: 10vh;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    font-size: 16rem;

    .rate_item {
      width: 50%;
      padding: 0 20px;

      .rate_item_link {
        color: #999;
        background-color: #d8eeff;
        text-decoration: none;
        padding: 2px 3px;
        border-radius: 4px;
      }

      .rate_item_price {
        font-size: 24rem;
        font-weight: bold;
        margin-top: 5px;
      }
    }
  }

  .info {
    height: 31.5vh;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.15);

    .info_row {
      height: 33.33%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      display: flex;
      padding-top: 10px;

      .info_row_item {
        width: 50%;
        padding: 0 15px;

        .info_row_item_price {
          font-size: 24rem;
          color: #0d94ff;
          font-weight: bold;
        }
      }
    }

    .useStatus {
      height: 33.33%;
      padding: 10px 15px 0;

      .useStatus_pic {
        display: flex;
        align-items: center;
        padding-top: 18rem;

        .useStatus_pic_div {
          width: 12rem;
          height: 28rem;
          border-radius: 6rem;
          margin-right: 5rem;
        }

        .useStatus_pic_num {
          font-size: 24rem;
          margin-left: 30rem;
          margin-right: 20rem;
        }

        .useStatus_pic_icon {
          font-size: 12rem;
          width: 25rem;
          height: 25rem;
          text-align: center;
          line-height: 25rem;
          color: #FFFFFF;
          border-radius: 50%;
          margin-right: 10rem;
        }
      }
    }
  }
}
</style>